import React, { useEffect, useState } from 'react';
import { toRoman } from 'roman-numerals';
import { getString } from '../../../strings';
import { getScores } from '../../../logic/requests/scores';
import { getRound } from '../../../logic/requests/rounds';
import { prepared, sorted, isExAequo } from '../../../logic/results';

import ResultsHeader from '../../molecules/Results/ResultsHeader';
import ResultsDataList from '../../molecules/Results/ResultsDataList';
import { StyledResultsData } from '../../atoms/Results/StyledResultsData';
import { StyledText } from '../../atoms/Text/StyledText';

const ResultsData = ({ eventId, competitionId, roundId, category, roundDisplay }) => {
    const [scores, setScores] = useState();
    const [competition, setCompetition] = useState('');
    const [nextRoundPlaces, setNextRoundPlaces] = useState(0);

    useEffect(() => {
        getRound(eventId, competitionId, roundId, {
            withCompetition: true,
        }).then((ret) => {
            setCompetition(ret.competition.name);
            // na zielono miejsca, które przechodzą do następnej rundy
            if (category) {
                // wyświetlamy wyniki dla kategorii - ilość miejsc z tabeli 'round_categories'
                setNextRoundPlaces(isNaN(category.winning_places) ? 0 : category.winning_places);
            } else {
                // wyświetlamy wyniki dla wszystkich kategorii - ilość miejsc z tabeli 'rounds'
                setNextRoundPlaces(isNaN(ret.winning_places) ? 0 : ret.winning_places);
            }
        });
        getScores(eventId, competitionId, roundId, {
            category_id: category ? category.id : undefined,
        }).then((ret) => setScores(sorted(prepared(ret))));
    }, [eventId, competitionId, roundId, category]);

    return (
        <StyledResultsData>
            <StyledText
                hasdeclaredtextalign="center"
                hasdeclaredfontsize="32px"
                hasdeclaredpadding="24px 0"
                hasdeclaredbgcolor="#F9EC4B"
                hasdeclaredfontweight="bold"
                as="h3"
            >
                {getString('results_resultsData_konkurencja')} {competition} -{' '}
                {isNaN(roundDisplay)
                    ? roundDisplay
                    : `${getString('results_resultsData_runda')} ${toRoman(roundDisplay)}`}
                {category
                    ? ` - ${getString('results_resultsData_kategoria')} ${category.name}`
                    : ''}
            </StyledText>
            <div>
                <ResultsHeader />
                {scores ? (
                    (() => {
                        let last = null;
                        return scores
                            .filter((score) => score.status.id !== 'hidden')
                            .map((score, index) => {
                                let idx = index;

                                if (isExAequo(last, score)) idx--;

                                last = score;

                                return (
                                    <ResultsDataList
                                        score={score}
                                        key={index}
                                        index={idx}
                                        active={idx < nextRoundPlaces ? true : false}
                                    />
                                );
                            });
                    })()
                ) : (
                    <></>
                )}
            </div>
        </StyledResultsData>
    );
};

export default ResultsData;
